import { Chip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const MappingWarningChip = ({ label }: { label: string }) => (
  <Chip
    icon={<WarningAmberIcon sx={{ fontSize: '16px', color: '#ed6c02 !important' }} />}
    label={label}
    sx={{
      backgroundColor: '#fff8e1',
      color: '#ed6c02',
      fontWeight: 500,
      borderRadius: '10px',
      '& .MuiChip-icon': { marginLeft: '8px' },
    }}
    size="small"
  />
);

export default MappingWarningChip;
